import careConfig from "@careConfig";
import { Link } from "raviger";
import { useTranslation } from "react-i18next";

export const AuthHero = () => {
  const { stateLogo, customLogo } = careConfig;
  const customDescriptionHtml = __CUSTOM_DESCRIPTION_HTML__;
  const appTitle = import.meta.env.REACT_APP_TITLE || "SEAES HMS";
  const { t } = useTranslation();

  const logos = [stateLogo, customLogo].filter(
    (logo) => logo?.light || logo?.dark,
  );

  return (
    <div className="login-hero order-last relative flex flex-auto flex-col justify-between p-6 md:order-first md:h-full md:w-[42%] md:flex-none md:p-0 md:px-16 md:pr-16">
      <div></div>
      <div className="mt-4 flex flex-col items-start rounded-lg py-4 md:mt-12">
        <div className="mb-4 hidden items-center gap-6 md:flex">
          {logos.map((logo, index) =>
            logo && logo.light ? (
              <div key={index} className="flex items-center">
                <img
                  src={logo.light}
                  className="h-16 rounded-lg py-3"
                  alt="state logo"
                />
              </div>
            ) : null,
          )}
          {logos.length === 0 && (
            <img
              src="/branding/logo-white.svg"
              className="h-16"
              alt="SEAES HMS"
            />
          )}
        </div>
        <div className="max-w-lg">
          <h1 className="text-4xl font-black leading-tight tracking-wider text-white lg:text-5xl">
            {appTitle}
          </h1>
          {customDescriptionHtml ? (
            <div className="py-6">
              <div
                className="max-w-xl text-secondary-400"
                dangerouslySetInnerHTML={{
                  __html: __CUSTOM_DESCRIPTION_HTML__,
                }}
              />
            </div>
          ) : (
            <div className="max-w-xl py-6 pl-1 text-base font-semibold text-secondary-400 md:text-lg lg:text-xl">
              {t("app_tagline")}
            </div>
          )}
        </div>
      </div>
      <div className="mb-6 flex items-center">
        <div className="max-w-lg text-xs md:text-sm">
          <p className="max-w-md text-secondary-500">{t("app_footer")}</p>
          <div className="mx-auto mt-2">
            <a
              href="https://hms.seaes.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-400 hover:text-primary-500"
            >
              hms.seaes.ai
            </a>
            <span className="mx-2 text-primary-400">|</span>
            <Link
              href="/licenses"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-400 hover:text-primary-500"
            >
              {t("license_notices")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
